
export const FbEvent = (eventType: string) => {
  // @ts-ignoreq
  window?.fbq('track', eventType);
  return { eventType };
};